module.exports = __webpack_public_path__ + "img/AT0000002570529.b8fb6e57.png";